import React from "react";
import { FileText, Smartphone, Server, Cloud, ChevronRight } from "lucide-react";

/**
 * Visual ladder showing the recommended automation journey: CSV → Mobile
 * → Bridge → Full Automation. Pure presentational; included verbatim from
 * design copy so judges instantly grasp the upgrade path.
 */
const STEPS = [
  { Icon: FileText,   label: "CSV",                hint: "Drop a file, see KPIs" },
  { Icon: Smartphone, label: "Mobile Local Sync",  hint: "Phone-on-Wi-Fi pulls" },
  { Icon: Server,     label: "Bridge",             hint: "On-prem device pushes 24/7" },
  { Icon: Cloud,      label: "Full Automation",    hint: "Cloud APIs, hands-off" },
];

export default function UpgradePath() {
  return (
    <section className="card-base p-5" data-testid="upgrade-path">
      <div className="label-tiny mb-3">Upgrade path</div>
      <div className="flex items-center gap-2 sm:gap-3 overflow-x-auto -mx-1 px-1">
        {STEPS.map((s, i) => (
          <React.Fragment key={s.label}>
            <div className="flex items-center gap-2 sm:gap-2.5 px-3 py-2 rounded-md border border-border min-w-fit" data-testid={`upgrade-step-${i}`}>
              <s.Icon className="w-3.5 h-3.5 text-foreground flex-shrink-0" />
              <div className="min-w-0">
                <div className="text-xs font-medium leading-tight whitespace-nowrap">{s.label}</div>
                <div className="text-[10px] text-muted-foreground leading-tight whitespace-nowrap">{s.hint}</div>
              </div>
            </div>
            {i < STEPS.length - 1 && <ChevronRight className="w-3 h-3 text-muted-foreground flex-shrink-0" aria-hidden />}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
}
